import type { UploadFile } from 'antd';
import type { RcFile } from 'antd/lib/upload';

export const mapToRcFiles = (files: UploadFile[]): RcFile[] =>
  files.map(file => file.originFileObj).filter((file): file is RcFile => file !== undefined);
